<template>
<div  class="mcontent">
    <layout
        type="L_R"
          v-if="root.device!='phone'"
            :class="[root.device=='ipad'&&'mipad','fs16']"
    >
        <layout type="T_B">
            <wrapper>
                <cusbox txt="年度成衣入库/出库走势">
                    <char1
                        :data="char1data"
                        :datelist="datelist"
                        v-if="getStockTrendResponseShow"
                    />
                    <dv-loading v-else>Loading...</dv-loading>
                </cusbox>
            </wrapper>
            <wrapper>
                <layout type="T_B">
                    <cusbox txt="出库复核排行榜">
                        <itemlist
                            v-if="getCheckAndPickedResponseShow"
                            :count='10'
                            :columns='columns1'
                            :data='data1'
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </layout>
                <layout
                    type="T_B"
                    style="margin-left:0.4vw;">
                    <cusbox txt="出库拣货排行榜">
                        <itemlist
                            v-if="getCheckAndPickedResponseShow2"
                            :count='10'
                            :columns='columns2'
                            :data='data2'
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </layout>
            </wrapper>
        </layout>
        <layout type="T_B">
             <wrapper>
                    <cusbox txt="仓储数据概览" v-if="getWarehouseOverviewShow">
                        <van-row type="flex">
                            <myvancol
                                title="本年度入库总数"
                                ref="count"
                                :value="data[0].number"
                               
                                :index="0"
                                :flex="1"
                            />
                            <myvancol
                                title="本年度出库总数"
                                :value="data[1].number"
                                 :index="1"
                                 :flex="1"
                            />
                        </van-row>
                        <van-row type="flex">
                            <myvancol
                                title="今日入库总数"
                                :value="data[2].number"
                               
                                :flex="1"
                                 :index="2"
                            />
                            <myvancol
                                title="今日出库总数"
                                :value="data[3].number"
                              
                                :flex="1"
                                 :index="3"
                            />
                        </van-row>
                        <van-row
                            style="margin-top:3vw;margin-left:1vw;"
                            type="flex"
                        >
                            <van-col>
                                <div style="color:#4EADFF"><span>今日入库</span></div>
                            </van-col>
                        </van-row>
                        
                        <layout type="L_R">
                             <layout type="T_B">
                                 <char2
                                  v-if="JSON.stringify(char2data)!='[]'"
                                        :data="char2data"
                                        :rd="['0%', '40%']"
                                    />
                             </layout>
                              <layout type="T_B">
                                 <char2
                                     v-if="JSON.stringify(char2data)!='[]'"
                                        :data="char2data2"
                                        :rd="['0%', '40%']"
                                    />
                             </layout>
                        </layout>

                        <van-row
                            style="margin-top:-3vw;margin-left:1vw;"
                            type="flex"
                        >
                            <van-col>
                                <div style="color:#4EADFF"><span>今日出库</span></div>
                            </van-col>
                        </van-row>
                       
                        <layout type="L_R">
                             <layout type="T_B">
                                 <char2
                                  v-if="JSON.stringify(char2data3)!='[]'"
                                        :data="char2data3"
                                        :rd="['0%', '40%']"
                                    />
                             </layout>
                              <layout type="T_B">
                                 <char2
                                 v-if="JSON.stringify(char2data4)!='[]'"
                                        :data="char2data4"
                                        :rd="['0%', '40%']"
                                    />
                             </layout>
                        </layout>
                    </cusbox>
                    <cusbox txt="仓储数据概览" v-else><dv-loading >Loading...</dv-loading></cusbox>
            

             </wrapper>
        </layout>
        <layout type="T_B">
                <wrapper>
                    <cusbox txt="入库TOP50">
                            <itemlist
                                :count='5'
                                v-if="getInTopResponseShow"
                                :columns='columns3'
                                :data='data3'
                            >
                                <template
                                    slot="ranking"
                                    slot-scope="{data}"
                                >
                                    <span v-if="data.ranking==1">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no1.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==2">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no2.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==3">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no3.png"
                                        />
                                    </span>
                                    <span v-else>
                                        {{data.ranking}}
                                    </span>
                                </template>
                                <template
                                    slot-scope="{data}"
                                    slot="img"
                                >
                                    <img
                                        style="width:2.5vw"
                                        :src="data.pics"
                                    />
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </wrapper>
                <wrapper>
                    <cusbox txt="出库TOP50">
                            <itemlist
                                :count='5'
                                :columns='columns4'
                                :data='data4'
                                v-if="getOutTopResponseShow"
                            >
                                <template
                                    slot="ranking"
                                    slot-scope="{data}"
                                >
                                    <span v-if="data.ranking==1">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no1.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==2">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no2.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==3">
                                        <img
                                            style="width:1vw"
                                            src="@/assets/no3.png"
                                        />
                                    </span>
                                    <span v-else>
                                        {{data.ranking}}
                                    </span>
                                </template>
                                <template
                                    slot-scope="{data}"
                                    slot="img"
                                >
                                    <img
                                        style="width:2.5vw"
                                        :src="data.pics"
                                    />
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </wrapper>
            </layout>
        
    </layout>
      <mobile class="device_phone ppd notransform" v-else>
        <div style="height:400px;margin-top:10px;"> 
                   <cusbox txt="仓储数据概览" v-if="getWarehouseOverviewShow">
                        <van-row type="flex" >
                            <myvancol
                                title="本年度入库总数"
                                ref="count"
                                :value="data.warehouse_total"
                             
                                :index="0"
                                :flex="1"
                            />
                            <myvancol
                                title="本年度出库总数"
                                :value="data.warehouse_out"
                               
                                 :index="1"
                                 :flex="1"
                            />
                        </van-row>
                        <van-row type="flex" >
                            <myvancol
                                title="今日入库总数"
                                :value="data.day_warehouse_total"
                              
                                :flex="1"
                                 :index="2"
                            />
                            <myvancol
                                title="今日出库总数"
                                :value="data.day_warehouse_out"
                              
                                :flex="1"
                                 :index="3"
                            />
                        </van-row>

                        <van-row
                            style="margin-top:3vw;margin-left:1vw;"
                            type="flex"
                        >
                            <van-col>
                                <div style="color:#4EADFF"><span>今日入库</span></div>
                            </van-col>
                        </van-row>
                        
                        <layout type="L_R">
                             <layout type="T_B">
                                 <char2
                                  v-if="JSON.stringify(char2data)!='[]'"
                                        :data="char2data"
                                        :rd="['0%', '60%']"
                                    />
                             </layout>
                        </layout>
                          <layout type="L_R">
                                    <char2
                                     v-if="JSON.stringify(char2data2)!='[]'"
                                        :data="char2data2"
                                        :rd="['0%', '60%']"
                                    />
                        </layout>
                        <van-row
                            style="margin-left:5px;"
                            type="flex"
                        >
                            <van-col>
                                <div style="color:#4EADFF"><span>今日出库</span></div>
                            </van-col>
                        </van-row>                       
                        <layout type="L_R">                          
                                 <char2
                                  v-if="JSON.stringify(char2data3)!='[]'"
                                        :data="char2data3"
                                        :rd="['0%', '60%']"
                                    />
                        </layout>
                        <layout type="L_R">
                                    <char2
                                     v-if="JSON.stringify(char2data4)!='[]'"
                                        :data="char2data4"
                                        :rd="['0%', '60%']"
                                    />
                        </layout>
                    </cusbox>  
                    <cusbox txt="仓储数据概览" v-else><dv-loading >Loading...</dv-loading></cusbox>     
        </div>
             <div style="height:250px;margin-top:10px;"> 
                <cusbox txt="年度成衣入库/出库走势">
                    <char1
                    v-if="getStockTrendResponseShow"
                        :data="char1data"
                        :datelist="datelist"
                    />
                    <dv-loading v-else>Loading...</dv-loading>
                </cusbox>
             </div>
              <div style="height:250px;margin-top:10px;"> 
                      <cusbox txt="出库复核排行榜">
                        <itemlist
                            v-if="getCheckAndPickedResponseShow"
                            :count='10'
                            :columns='columns1'
                            :data='data1'
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
              </div>
               <div style="height:250px;margin-top:10px;"> 
                    <cusbox txt="出库拣货排行榜">
                        <itemlist
                            :count='10'
                            :columns='columns2'
                            :data='data2'
                            v-if="getCheckAndPickedResponseShow2"
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
               </div>

               <div style="height:250px;margin-top:10px;">
                    <cusbox txt="入库TOP50">
                            <itemlist
                                v-if="getInTopResponseShow"
                                :count='5'
                                :columns='cols_3'
                                :data='data3'
                            >
                                <template
                                    slot="ranking"
                                    slot-scope="{data}"
                                >
                                    <span v-if="data.ranking==1">
                                        <img
                                             style="width:15px"
                                            src="@/assets/no1.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==2">
                                        <img
                                             style="width:15px"
                                            src="@/assets/no2.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==3">
                                        <img
                                             style="width:15px"
                                            src="@/assets/no3.png"
                                        />
                                    </span>
                                    <span v-else>
                                        {{data.ranking}}
                                    </span>
                                </template>
                                <template
                                    slot-scope="{data}"
                                    slot="img"
                                >
                                    <img
                                        class="icon"
                                        :src="data.pics"
                                    />
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
               </div>
                 <div style="height:250px;margin-top:10px;">
                           <cusbox txt="出库TOP50">
                            <itemlist
                                :count='5'
                                :columns='cols_4'
                                v-if="getOutTopResponseShow"
                                :data='data4'
                            >
                                <template
                                    slot="ranking"
                                    slot-scope="{data}"
                                >
                                    <span v-if="data.ranking==1">
                                        <img
                                             style="width:15px"
                                            src="@/assets/no1.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==2">
                                        <img
                                           style="width:15px"
                                            src="@/assets/no2.png"
                                        />
                                    </span>
                                    <span v-else-if="data.ranking==3">
                                        <img
                                            style="width:15px"
                                            src="@/assets/no3.png"
                                        />
                                    </span>
                                    <span v-else>
                                        {{data.ranking}}
                                    </span>
                                </template>
                                <template
                                    slot-scope="{data}"
                                    slot="img"
                                >
                                    <img
                                         class="icon"
                                        :src="data.pics"
                                    />
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                 </div>
      </mobile>
  </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import itemlist from "@/components/cuscom/itemlist";
import char1 from "./report/char1.vue";
import myvancol from "./report/vancol.vue";
import char2 from "./report/char2.vue";
import {cols_3,cols_4} from "./device/phone_column.js"
export default {
  components: { layout, wrapper, cusbox, itemlist, char1, myvancol, char2 },
    inject:['root'],
  data() {
    return {
      cols_3,
      cols_4,
      api: this.$apis["warehouse"],
      columns1: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking",
          width:'2.5vw'
        },
        {
          title: "姓名",
          key: "who",
          align: "center"
        },
        {
          title: "扫描数",
          key: "number",
          align: "center"
        }
      ],
      columns2: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking"
        },
        {
          title: "姓名",
          key: "who",
          align: "center"
        },
        {
          title: "拣货数",
          key: "number",
          align: "center"
        }
      ],
      columns3: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking",
           width:'2.5vw'
        },
        {
          title: "图片",
          key: "pics",
          align: "center",
          slot: "img"
        },
        {
          title: "款号",
          key: "goodsNo",
          align: "center",
          width:'6vw'
        },
        {
          title: "累计入库",
          key: "number",
          align: "center"
        },
        {
          title: "销量",
          key: "number",
          align: "quantity"
        },
        {
          title: "大仓库存",
          key: "warehouseQty",
          align: "center"
        },
        {
          title: "店铺库存",
          key: "storeQty",
          align: "center"
        }
      ],

      columns4: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking",
          width:'2.5vw'
        },
        {
          title: "图片",
          key: "pics",
          align: "center",
          slot: "img"
        },
        {
          title: "款号",
          key: "goodsNo",
          align: "center",
          width:'6vw'
        },
        {
          title: "累计出库",
          key: "number",
          align: "center"
        },
        {
          title: "销量",
          key: "quantity",
          align: "center"
        },
        {
          title: "大仓库存",
          key: "warehouseQty",
          align: "center"
        },
        {
          title: "店铺库存",
          key: "storeQty",
          align: "center"
        }
      ],
      data1: [],
      data2: [],
      data3: [],
      getInTopResponseShow:false,
      data4: [],
      getOutTopResponseShow:false,
      getCheckAndPickedResponseShow2:false,
      char2data: [
        // {
        //   value: 67,
        //   name: "退货入库",
        //   itemStyle: { color: "#6648FF" },
        //   showvalue: "67"
        // },
        // {
        //   value: 130,
        //   name: "新品入库",
        //   itemStyle: { color: "#4346D3" },
        //   showvalue: "130"
        // }
      ],
      char2data2: [
        // {
        //   value: 67,
        //   name: "线下入库",
        //   itemStyle: { color: "#6648FF" },
        //   showvalue: "67"
        // },
        // {
        //   value: 130,
        //   name: "线上入库",
        //   itemStyle: { color: "#4346D3" },
        //   showvalue: "130"
        // }
      ],
      getWarehouseOverviewShow:false,
      char2data3: [
        // {
        //   value: 67,
        //   name: "预售销补-待发",
        //   itemStyle: { color: "#6648FF" },
        //   showvalue: "67"
        // },
        // {
        //   value: 130,
        //   name: "预售销补-已发",
        //   itemStyle: { color: "#4346D3" },
        //   showvalue: "130"
        // }
      ],
      char2data4: [
        // {
        //   value: 67,
        //   name: "配货出库-待发",
        //   itemStyle: { color: "#6648FF" },
        //   showvalue: "67"
        // },
        // {
        //   value: 130,
        //   name: "配货出库-已发",
        //   itemStyle: { color: "#4346D3" },
        //   showvalue: "130"
        // }
      ],
      char1data: {},
      getStockTrendResponseShow:false,
      getCheckAndPickedResponseShow:false,
      datelist: [],
      data: [{
          number:0
      },{
          number:0
      },{
          number:0
      },{
          number:0
      },{
          number:0
      },{
          number:0
      },{
          number:0
      }]
    };
  },
  mounted() {
      let that = this
    this.api.getStockTrendResponse().then(res => {     
      var obj = { date: [], data1: [], data2: [] };     
      var line1=res.data.list.filter(item=>item.type=='IN').map(item=>item.number)
      var line2=res.data.list.filter(item=>item.type=='OUT').map(item=>item.number)
       
      for (var i = 0; i < res.data.list.length; i++) {     
        obj.date.push(res.data.list[i].date+'月');
        obj.data1[i]=line1[i]||0;
        obj.data2[i]=line2[i]||0;          
      }
     this.getStockTrendResponseShow=true
     let that = this
     setTimeout(function(){
         that.char1data = obj;
        that.datelist = obj.date;
     },0)
      
    });
    this.api.getCheckAndPickedResponse().then(res => {
        let data1_ = []
        let data2_ = []
        if(res.data.checkList){
            for(var s=0;s<res.data.checkList.length;s++){
                     data1_.push({
                         ...res.data.checkList[s],
                         ranking:s+1
                     })
                }
                this.getCheckAndPickedResponseShow = true
                setTimeout(function(){
                    that.data1 =data1_;
                },0)
                      //出库复核排行榜
        }
         if(res.data.pickedList){
            for(var j=0;j<res.data.pickedList.length;j++){
                     data2_.push({
                         ...res.data.pickedList[j],
                         ranking:j+1
                     })
                }
            this.getCheckAndPickedResponseShow2 = true
             setTimeout(function(){
                    that.data2 =data2_;
                },0)
        }
     
    });    
    this.api.getInTopResponse().then(res => {  
        let data3_=[]    
        for(var f=0;f<res.data.list.length;f++){
            data3_.push({
                ...res.data.list[f],
                ranking:f+1
            })
        }  
       this.getInTopResponseShow = true
       setTimeout(function(){that.data3 = data3_;},0) 
      
    });
    this.api.getOutTopResponse().then(res => {
        let data4_=[]
        for(var e=0;e<res.data.list.length;e++){
            data4_.push({
                ...res.data.list[e],
                ranking:e+1
            })
        }  
        this.getOutTopResponseShow = true
       setTimeout(function(){that.data4 = data4_;},0)     
    });
    this.api.getWarehouseOverview().then(res => {   
        this.getWarehouseOverviewShow = true
    setTimeout(function(){
      that.data = res.data.list;

   
      that.char2data= [
           {
          value: that.data[4].number,
          name: "退货入库",
          itemStyle: { color: "#6648FF" },
          showvalue: that.data[4].number
        },
        {
          value: that.data[5].number,
          name: "新品入库",
          itemStyle: { color: "#4346D3" },
          showvalue: that.data[5].number
        }
       
      ]      
      that.char2data2= [
         {
          value: that.data[6].number,
          name: "线下入库",
          itemStyle: { color: "#6648FF" },
          showvalue: that.data[6].number
        },
        {
          value: that.data[7].number,
          name: "线上入库",
          itemStyle: { color: "#4346D3" },
          showvalue: that.data[7].number
        }
      ]
      
       that.char2data3= [
        {
          value: that.data[9].number,
          name: "预售销补-待发",
          itemStyle: { color: "#6648FF" },
          showvalue:  that.data[9].number
        },
        {
          value:  that.data[8].number,
          name: "预售销补-已发",
          itemStyle: { color: "#4346D3" },
          showvalue:  that.data[8].number
        }
      ]
      
       that.char2data4= [
        {
          value: that.data[11].number,
          name: "配货出库-待发",
          itemStyle: { color: "#6648FF" },
          showvalue: that.data[11].number
        },
        {
          value: that.data[10].number,
          name: "配货出库-已发",
          itemStyle: { color: "#4346D3" },
          showvalue: that.data[10].number
        }
      ]
      
        },0)
   
   

    });
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  }
</style>
